import React, { useState, useCallback } from 'react';
import EDTypography from '../../../../../../../../../BaseComponents/Typography/EDTypography';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import EkonomiskAnalysKodbehorighetMenu from '../EkonomiskAnalysKodbehorighetMenu/EkonomiskAnalysKodbehorighetMenu';
import classNames from 'classnames';
import {
  ISelectedAnalys,
  ISelectedAnalysCodePrivilege,
} from '../../../../EkonomiskAnalysPage';

interface IProps {
  impersonatedCodePrivilege?: ISelectedAnalysCodePrivilege;
  anvandsFor: string[];
  updateImpersonatedCodePrivilege: (
    codePrivilege?: ISelectedAnalysCodePrivilege
  ) => void;
  hasWholeBook: boolean;
  codePrivileges: ISelectedAnalysCodePrivilege[];
  selectedAnalys: ISelectedAnalys;
  kodbehorighetNamn?: string;
  ingaendeKodbehorigheter?: ISelectedAnalysCodePrivilege[] | null;
  classes?: any;
  sammanfattningsMode?: boolean;
}

const styles = (theme: Theme) => ({
  label: {
    display: 'inline',
    whiteSpace: 'nowrap',
  },
  flexContainer: {
    display: 'flex',
    alignItems: 'center',
    color: theme.customProperties.Fade.DarkOnLight.highEmphasis,
    position: 'relative',
  },
  invertedText: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.customProperties.Fade.LightOnDark.highEmphasis,
    padding: '0 4px',
  },
  menu: {
    backgroundColor: theme.palette.common.white,
    borderRadius: 4,
    boxShadow: theme.shadows[3],
    padding: 5,
    position: 'absolute',
    top: 20,
    width: '280px',
    zIndex: 100,
  },
});

/**
 * Textinformation om användarens kodbehörighet. Om användaren har behörighet till hela huvudboken så kan alternativa kodbehörigheter väljas.
 */
export const EkonomiskAnalysKodbehorighet: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const [displayMenu, setDisplayMenu] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const {
    classes,
    impersonatedCodePrivilege,
    anvandsFor,
    hasWholeBook,
    codePrivileges,
    selectedAnalys,
    ingaendeKodbehorigheter,
  } = props;

  const hasIngaendeKodbeh =
    ingaendeKodbehorigheter != null && ingaendeKodbehorigheter.length > 1;

  const showMenu = hasWholeBook || hasIngaendeKodbeh;

  const onChange = useCallback(() => setDisplayMenu(false), []);
  const onBlur = useCallback(() => {
    setIsClosing(true);
    setDisplayMenu(false);
    setTimeout(() => setIsClosing(false), 300);
  }, []);

  const onClick = useCallback(() => {
    if (!isClosing) {
      setDisplayMenu(true);
    }
  }, [isClosing]);

  return (
    <>
      <div
        className={classNames(classes.flexContainer, {
          [classes.invertedText]: impersonatedCodePrivilege,
        })}
      >
        {showMenu && (
          <>
            <span onClick={onClick}>
              <EDTypography
                variant="body2"
                className={classes.label}
                color="inherit"
                bold
              >
                Kodbehörighet:
              </EDTypography>
              &nbsp;
              <EDTypography
                variant="body2"
                className={classes.label}
                color="inherit"
              >
                {props.kodbehorighetNamn}
              </EDTypography>
            </span>
            {displayMenu && (
              <div className={classes.menu}>
                <EkonomiskAnalysKodbehorighetMenu
                  anvandsFor={anvandsFor}
                  codePrivileges={
                    hasIngaendeKodbeh
                      ? props.ingaendeKodbehorigheter ?? []
                      : codePrivileges
                  }
                  disableArrowIcon
                  kodbehorighetNamn={props.kodbehorighetNamn}
                  selectedAnalys={selectedAnalys}
                  updateImpersonatedCodePrivilege={
                    props.updateImpersonatedCodePrivilege
                  }
                  onChange={onChange}
                  onBlur={onBlur}
                />
              </div>
            )}
          </>
        )}
        {!showMenu && (
          <span>
            <EDTypography
              variant="body2"
              className={classes.label}
              color="inherit"
              bold
            >
              Kodbehörighet:
            </EDTypography>
            &nbsp;
            <EDTypography
              variant="body2"
              className={classes.label}
              color="inherit"
            >
              {props.kodbehorighetNamn}
            </EDTypography>
          </span>
        )}
      </div>
    </>
  );
};

export default withStyles(EkonomiskAnalysKodbehorighet, styles);
